import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface WaitingRoomCountResponse {
  waitingRoomCount: number;
}

export const useWaitingRoomCount = (enabled = true) => {
  return useApi<WaitingRoomCountResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<WaitingRoomCountResponse>(
          "/new-api/waiting-room-dashboard/count",
        );
        return response.data;
      },
      queryKey: QueryKeys.Provider.LiveQueueDashboard.COUNT,
    },
  });
};
